import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "home-page"
};
var _hoisted_2 = {
  class: "main-list"
};
var _hoisted_3 = {
  class: "hang-div"
};
var _hoisted_4 = {
  class: "visitors-list"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  key: 0,
  class: "visitor_left"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "left_name"
};
var _hoisted_9 = {
  class: "student_name"
};
var _hoisted_10 = {
  class: "school_name"
};
var _hoisted_11 = {
  key: 2,
  class: "visitor_right"
};
var _hoisted_12 = {
  key: 3,
  class: "base_name"
};
var _hoisted_13 = {
  class: "lately-visitor"
};
var _hoisted_14 = {
  key: 0,
  class: "lately_list"
};
var _hoisted_15 = {
  class: "user"
};
var _hoisted_16 = {
  class: "user_left"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  class: "name"
};
var _hoisted_19 = {
  class: "user_time"
};
var _hoisted_20 = {
  key: 1,
  class: "no_content"
};
import { toRefs, ref, watch, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { formatRelativeDate } from '@/util/date';
/** 组件 */
import itemTitle from './itemTitle.vue';
import ActivityPage from '@/views/stuSpaceInfo/activity/index.vue';
import LessonPage from '@/views/stuSpaceInfo/lesson/index.vue';
import NotePage from '@/views/stuSpaceInfo/note/index.vue';
import calling from '@/views/spaceInfo/home/calling.vue';

/** api */
import { pokeAround, userSpaceSearch, getRecentVisitor } from '@/api/spaceInfo.js';

/** 工具 */
import { throttle } from '@/util/util.js';
import { MessagePlugin } from 'tdesign-vue-next';
import { ChevronRightDoubleIcon } from 'tdesign-icons-vue-next';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    visitorType: {
      // 0:游客 1:自己(自己访问自己空间仍为个人视角)  2:公开
      type: Number,
      default: 0
    },
    curUserId: {
      type: String
    },
    showScope: {
      type: String
      // default: '0'
    },
    avatarImg: {
      // 学生头像
      type: String,
      default: ''
    },
    spaceInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['update:modelValue', 'changeId'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var baseImg = require('@/assets/home/baseImg.svg');
    var props = __props;
    var _toRefs = toRefs(props),
      curUserId = _toRefs.curUserId,
      avatarImg = _toRefs.avatarImg;
    var emit = __emit;
    var route = useRoute();
    var visListShow = computed(function () {
      return props.visitorType;
    });
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    // 查看更多
    var changeTab = function changeTab(index) {
      emit('update:modelValue', index);
    };

    // 随便逛逛
    // 随便逛逛
    var handleRandom = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _userInfo$memberType, _yield$pokeAround, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return pokeAround({
                platform: (_userInfo$memberType = userInfo.memberType) !== null && _userInfo$memberType !== void 0 && _userInfo$memberType.some(function (role) {
                  return role === 'teacher';
                }) ? 0 : 1,
                currentHomeUserId: props.spaceInfo.id
              });
            case 1:
              _yield$pokeAround = _context.v;
              data = _yield$pokeAround.data;
              if (data.data) {
                emit('changeId', data.data.userId, 0, data.data.userType);
              } else {
                MessagePlugin.warning('暂无可随便逛逛主页');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function handleRandom() {
        return _ref2.apply(this, arguments);
      };
    }();
    var hangAround = throttle(function () {
      handleRandom();
    }, 1000);
    // 搜索数据
    var searchIdName = ref('');
    var showMe = ref(false);
    var peopleList = ref({}); // 搜索时展现的数据
    // 搜索
    var handleSearch = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$userSpaceSearc, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(searchIdName.value === '')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, MessagePlugin.error('请输入主页ID,不能为空'));
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return userSpaceSearch(searchIdName.value);
            case 2:
              _yield$userSpaceSearc = _context2.v;
              data = _yield$userSpaceSearc.data;
              peopleList.value = data.data;
              showMe.value = true;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function handleSearch() {
        return _ref3.apply(this, arguments);
      };
    }();
    // 监听搜索页面的弹出
    watch(function () {
      return searchIdName.value;
    }, function (val) {
      if (val === '') {
        showMe.value = false;
      }
    });
    var visList = ref([]); // 最近访客
    // 访客列表
    var getUserInfoList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$getRecentVisit, data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return getRecentVisitor(curUserId.value);
            case 1:
              _yield$getRecentVisit = _context3.v;
              data = _yield$getRecentVisit.data;
              visList.value = data.data;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              MessagePlugin.error('请求失败，请重试');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      return function getUserInfoList() {
        return _ref4.apply(this, arguments);
      };
    }();
    watch(function () {
      return curUserId.value;
    }, function (val) {
      if (val) {
        getUserInfoList();
      }
    }, {
      immediate: true
    });
    // 列表详情
    var cardInfo = ref(0);
    var handleVisibleChange = function handleVisibleChange(index) {
      cardInfo.value = index;
    };
    // 点击进入主页
    var backHomeMe = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(val) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              showMe.value = false;
              emit('changeId', val.userId, 0, val.userType);
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function backHomeMe(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    // 点击菜单外区域关闭菜单
    var menuOutClick = function menuOutClick(e) {
      var popDiv = document.querySelector('.pop-div');
      if (!(popDiv !== null && popDiv !== void 0 && popDiv.contains(e.target))) {
        showMe.value = false;
      }
    };
    var changeToHome = function changeToHome(val, userType) {
      emit('changeId', val, 0, userType);
    };
    onMounted(function () {
      document.addEventListener('click', menuOutClick);
    });
    onUnmounted(function () {
      document.removeEventListener('click', menuOutClick);
    });
    return function (_ctx, _cache) {
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(itemTitle, {
        title: "我的活动",
        tip: "展示已参加的活动，不包含已下架活动",
        onChangeTab: _cache[0] || (_cache[0] = function ($event) {
          return changeTab(1);
        })
      }), _createVNode(ActivityPage, {
        visitorType: __props.visitorType,
        showScope: __props.showScope,
        useToHome: true,
        curUserId: _unref(curUserId)
      }, null, 8, ["visitorType", "showScope", "curUserId"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "flex-div",
        onClick: _cache[1] || (_cache[1] = function () {
          return _unref(hangAround) && _unref(hangAround).apply(void 0, arguments);
        })
      }, [_cache[4] || (_cache[4] = _createTextVNode(" 随便逛逛 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon), {
        class: "right-icon"
      })]), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "light-color"
      }, "随便逛逛本校师生的个人主页", -1))])]), _createElementVNode("div", _hoisted_4, [visListShow.value === 1 ? (_openBlock(), _createBlock(_component_t_input, {
        key: 0,
        modelValue: searchIdName.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return searchIdName.value = $event;
        }),
        placeholder: "请输入主页ID"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "icon-search",
            onClick: handleSearch
          }, [_createElementVNode("img", {
            src: require('@/assets/home/search.svg'),
            alt: ""
          }, null, 8, _hoisted_5)])];
        }),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), showMe.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([peopleList.value ? 'visitor-name' : 'visitor-base', 'pop-div'])
      }, [peopleList.value && peopleList.value.isLocalUser === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
        src: peopleList.value.avatar || _unref(baseImg),
        alt: ""
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(peopleList.value.name), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(peopleList.value.schoolName), 1)])])) : _createCommentVNode("", true), peopleList.value && peopleList.value.isLocalUser === 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "visitor_right right_button",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return backHomeMe(peopleList.value);
        })
      }, [_cache[6] || (_cache[6] = _createTextVNode(" 进入主页 ", -1)), _createVNode(_unref(ChevronRightDoubleIcon))])) : _createCommentVNode("", true), peopleList.value && peopleList.value.isLocalUser === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, "暂不支持查看学校外个人主页")) : _createCommentVNode("", true), !peopleList.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, "主页ID有误，请重新输入")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "lately_title"
      }, "最近访客", -1)), visList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createVNode(_component_t_popup, {
          placement: "left-bottom",
          "overlay-style": {
            padding: '16px'
          },
          onVisibleChange: function onVisibleChange($event) {
            return handleVisibleChange(index);
          }
        }, {
          content: _withCtx(function () {
            return [_createVNode(calling, {
              item: item.id,
              index: index,
              cardInfo: cardInfo.value,
              spaceInfo: __props.spaceInfo,
              onChangeToHome: changeToHome
            }, null, 8, ["item", "index", "cardInfo", "spaceInfo"])];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
              src: item.avatar || _unref(baseImg),
              alt: ""
            }, null, 8, _hoisted_17), _createElementVNode("span", _hoisted_18, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(formatRelativeDate)(item.time)), 1)])];
          }),
          _: 2
        }, 1032, ["onVisibleChange"])]);
      }), 128))])) : _createCommentVNode("", true), visList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, "暂无访客")) : _createCommentVNode("", true)])])]);
    };
  }
};